import fgInput from './components/Inputs/formGroupInput.vue';
import DropDown from './components/Dropdown.vue';
import Card from './components/Cards/Card.vue';
import Button from './components/Button.vue';
import {
  Aside,
  Badge,
  Button as ElButton,
  Checkbox,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Descriptions,
  DescriptionsItem,
  Dialog,
  Image,
  Input,
  InputNumber,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Option,
  Select,
  Submenu,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  TimePicker,
  Tooltip,
  Upload,
  ButtonGroup,
  ColorPicker
} from 'element-ui';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Skeleton } from 'vue-loading-skeleton';

import CardFooter from '/src/components/Tables/CardFooter.vue';
import CardHeader from '/src/components/Tables/CardHeader.vue';
import ContentShowDialog from 'src/components/Dialogs/ContentShowDialog.vue';
import CustomSelect from '/src/components/Selects/Select.vue';
import ExportTables from '/src/components/Tables/ExportTables.vue';
import FooterDateAt from 'src/components/Dialogs/FooterDateAt.vue';
import HeaderAdd from '/src/components/Masters/HeaderAdd.vue';
import IconWarning from '/src/components/IconWarning.vue';
import MasterTable from '/src/components/Tables/MasterTable.vue';
import NotIndex from '/src/components/Permissions/NotIndex.vue';
import TableColumnsBadges from '/src/components/Tables/TableColumnBadges.vue';
import TableColumnsOperations from './components/Tables/TableColumnOperations.vue';
import ValueFormatedMoney from '/src/components/ValueFormatedMoney.vue';
import ValueFormatedNumber from '/src/components/ValueFormatedNumber.vue';
import Businesses from 'src/components/Selects/Businesses.vue';
import SelectAddress from 'src/components/Selects/Address.vue';
import CreateDialog from 'src/components/Dialogs/CreateDialog';
import TranslateText from 'src/components/Texts/TranslateText.vue';
import ContractInfo from 'src/components/ContractInfo.vue';
import LoadingComponent from 'src/components/Loading.vue';
import HourTimeFormat from 'src/components/Texts/HourTimeFormat.vue';
import PriceFormat from 'src/components/Texts/PriceFormat.vue';
import ValueActivitiesInfo from 'src/views/Pages/Dashboard/Work/ActivityValues/ValueActivitiesInfo.vue';
import RateTypesInfo from 'src/views/Pages/Dashboard/Work/ActivityValues/RateTypesInfo.vue';

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component('card', Card);
    Vue.component('drop-down', DropDown);
    Vue.component('el-button', ElButton);
    Vue.component('fg-input', fgInput);
    Vue.component('format-number', ValueFormatedNumber);
    Vue.component('translate-text', TranslateText);
    Vue.component('hour-time-format', HourTimeFormat);
    Vue.component('price-format', PriceFormat);
    Vue.component('value-activities-info', ValueActivitiesInfo);
    Vue.component('rate-types-info', RateTypesInfo);
    Vue.component('contract-info', ContractInfo);
    Vue.component('format', ValueFormatedMoney);
    Vue.component('iconwarning', IconWarning);
    Vue.component('loading', Loading);
    Vue.component(Aside.name, Aside);
    Vue.component(Badge.name, Badge);
    Vue.component(Button.name, Button);
    Vue.component(CardFooter.name, CardFooter);
    Vue.component(CardHeader.name, CardHeader);
    Vue.component(Checkbox.name, Checkbox);
    Vue.component(Collapse.name, Collapse);
    Vue.component(CollapseItem.name, CollapseItem);
    Vue.component(Container.name, Container);
    Vue.component(ContentShowDialog.name, ContentShowDialog);
    Vue.component(CustomSelect.name, CustomSelect);
    Vue.component(DatePicker.name, DatePicker);
    Vue.component(Descriptions.name, Descriptions);
    Vue.component(DescriptionsItem.name, DescriptionsItem);
    Vue.component(Dialog.name, Dialog);
    Vue.component(ExportTables.name, ExportTables);
    Vue.component(FooterDateAt.name, FooterDateAt);
    Vue.component(HeaderAdd.name, HeaderAdd);
    Vue.component(Input.name, Input);
    Vue.component(InputNumber.name, InputNumber);
    Vue.component(Main.name, Main);
    Vue.component(MasterTable.name, MasterTable);
    Vue.component(Menu.name, Menu);
    Vue.component(MenuItem.name, MenuItem);
    Vue.component(MenuItemGroup.name, MenuItemGroup);
    Vue.component(NotIndex.name, NotIndex);
    Vue.component(Option.name, Option);
    Vue.component(Select.name, Select);
    Vue.component(Skeleton.name, Skeleton);
    Vue.component(Submenu.name, Submenu);
    Vue.component(Switch.name, Switch);
    Vue.component(Table.name, Table);
    Vue.component(TableColumn.name, TableColumn);
    Vue.component(TableColumnsBadges.name, TableColumnsBadges);
    Vue.component(TableColumnsOperations.name, TableColumnsOperations);
    Vue.component(TabPane.name, TabPane);
    Vue.component(Tabs.name, Tabs);
    Vue.component(Tag.name, Tag);
    Vue.component(TimePicker.name, TimePicker);
    Vue.component(Tooltip.name, Tooltip);
    Vue.component(Upload.name, Upload);
    Vue.component(Businesses.name, Businesses);
    Vue.component(SelectAddress.name, SelectAddress);
    Vue.component(CreateDialog.name, CreateDialog);
    Vue.component(Image.name, Image);
    Vue.component(LoadingComponent.name, LoadingComponent);
    Vue.component(ButtonGroup.name, ButtonGroup);
    Vue.component(ColorPicker.name, ColorPicker);

  },
};

export default GlobalComponents;
